/**
 * Block type aliases, legacy mapping, and resolution — leaf module (no registry / model imports).
 * Keep BLOCK_TYPE_KEYS in sync with keys on BLOCKS_REGISTRY.
 */

export const BLOCK_TYPE_ALIASES = Object.freeze({
  block_mantra: 'block_quote',
})

/** Legacy section types → block types (read-time migration) */
export const LEGACY_TO_BLOCK = Object.freeze({
  richtext: 'block_richtext',
  callout: 'block_callout',
  insight: 'block_insight',
  tabs: 'block_tabs',
  steps: 'block_steps',
  content: 'block_summary',
  focus: 'block_richtext',
  list: 'block_question',
  status: 'block_lesson_tracker',
  code: 'block_code',
  media: 'block_media',
  compare: 'block_summary',
  decision: 'block_question',
  snapshot: 'block_reference',
  equation: 'block_richtext',
  divider: 'block_rule',
  toggle: 'block_richtext',
  layout: 'block_zone_grid',
})

/** Canonical registry keys — must match BLOCKS_REGISTRY object keys */
export const BLOCK_TYPE_KEYS = Object.freeze([
  'block_card',
  'block_supporting_notes',
  'block_badge',
  'block_callout',
  'block_quote',
  'block_code',
  'block_media',
  'block_rule',
  'block_zone_grid',
  'block_warning_box',
  'block_daily_row',
  'block_step_row',
  'block_steps',
  'block_hero',
  'block_tabs',
  'block_richtext',
  'block_insight',
  'block_summary',
  'block_question',
  'block_reference',
  'block_timeline',
  'block_interviewer_test',
  'block_lesson_tracker',
])

const BLOCK_TYPE_KEY_SET = new Set(BLOCK_TYPE_KEYS)

/**
 * @param {string} type
 * @param {ReadonlySet<string>} [knownKeys]
 */
export function resolveBlockType(type, knownKeys = BLOCK_TYPE_KEY_SET) {
  const aliased = BLOCK_TYPE_ALIASES[type] ?? type
  if (knownKeys.has(aliased)) return aliased
  if (LEGACY_TO_BLOCK[type]) return LEGACY_TO_BLOCK[type]
  return 'block_richtext'
}
